import { FirebaseFunctions } from '../../capacitor.plugin';
import { FirebaseFunctionsInterface } from './functions.interface';

export class FirebaseFunctionsNative implements FirebaseFunctionsInterface {
  async httpsCallable<T, U>(fn: string, payload: T): Promise<U> {
    const { result } = await FirebaseFunctions.httpsCallable<T, U>({ fn, payload });
    return result;
  }
}
